<template>
  <div>
    <v-layout row wrap class="px-3">
      <v-flex xs12 sm6>
        <v-menu
          ref="startMenu"
          v-model="startMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              label="Start Date"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="startMenu = false"
            color="black"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6>
        <v-menu
          ref="endMenu"
          v-model="endMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              label="End Date"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="endMenu = false"
            color="black"
          ></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <!-- Search Field -->
    <div class="px-3">
      <v-text-field
        v-model="search"
        prepend-icon="search"
        :label="'Search by details'"
        single-line
        hide-details
        clearable
        @input="filterTransactions"
      ></v-text-field>
    </div>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-flex xs12 sm4 d-flex class="text-xs-center">
        <v-btn
          class="export-btn yellow-btn mx-2"
          @click="openExportDialog('csv')"
        >
          <v-icon left color="black">mdi-file-delimited</v-icon>
          <span style="color: black">Export CSV</span>
        </v-btn>
        <v-btn
          class="export-btn yellow-btn mx-2"
          @click="openExportDialog('xls')"
        >
          <v-icon left color="black">mdi-file-excel</v-icon>
          <span style="color: black">Export xls</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="exportDialog" max-width="700px" scrollable persistent>
      <v-card class="export-dialog-card">
        <!-- Modern Header -->
        <div class="export-dialog-header">
          <div class="header-icon">
            <v-icon color="#ffd600" size="32">mdi-download</v-icon>
          </div>
          <div class="header-content">
            <h2 class="header-title">Export Transactions</h2>
            <p class="header-subtitle">
              Download CSV/XLSX files split by your preference
            </p>
          </div>
          <v-btn
            icon
            @click="exportDialog = false"
            class="close-btn"
            :disabled="false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="export-dialog-content">
          <v-form class="export-form">
            <div class="form-section">
              <div class="section-header">
                <h4 class="section-title">
                  <v-icon color="#ffd600" class="mr-2"
                    >mdi-file-multiple</v-icon
                  >
                  Export Options
                </h4>
              </div>
              <div class="form-grid">
                <v-text-field
                  v-model.number="exportSplitCount"
                  type="number"
                  min="1"
                  :max="maxExportSplit"
                  label="Number of files to split"
                  hint="Split export into multiple files for large datasets"
                  persistent-hint
                  outlined
                  color="#ffd600"
                  class="form-field"
                ></v-text-field>
              </div>
              <v-alert
                type="info"
                dense
                border="left"
                color="primary"
                class="mb-0 mt-2"
              >
                Total rows: <b>{{ filteredTransactions.length }}</b> | Max
                files: <b>{{ maxExportSplit }}</b>
              </v-alert>
            </div>
            <v-divider class="my-4"></v-divider>
            <div class="form-section">
              <div class="section-header">
                <h4 class="section-title">
                  <v-icon color="#ffd600" class="mr-2"
                    >mdi-file-download</v-icon
                  >
                  Download Files
                </h4>
              </div>
              <v-row>
                <v-col
                  v-for="(file, idx) in exportFileList"
                  :key="idx"
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-card class="download-file-card mb-3" outlined>
                    <v-card-title class="d-flex align-center">
                      <span class="font-weight-bold">{{ file.name }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-chip
                        small
                        color="primary"
                        text-color="white"
                        class="mr-2"
                        >{{ file.range }}</v-chip
                      >
                      <span
                        >Rows: <b>{{ file.data.length }}</b></span
                      >
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <download-excel
                        :data="file.data"
                        :fields="exportFields"
                        :name="file.name"
                        :type="exportType"
                      >
                        <v-btn block class="download-btn black-btn">
                          <v-icon left color="white">mdi-download</v-icon>
                          <span style="color: white">Download</span>
                        </v-btn>
                      </download-excel>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <div
                v-if="exportFileList.length === 0"
                class="text-xs-center grey--text mt-4"
              >
                <v-icon large color="grey lighten-1">mdi-file-remove</v-icon>
                <div>No data to export.</div>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="export-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="exportDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="filteredTransactions"
      :pagination.sync="pagination"
      :rows-per-page-items="[50, 100, 200]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ filteredTransactions.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-center">{{ props.item.wt_date }}</td>
        <td class="text-xs-center">{{ props.item.wt_time }}</td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wt_after_money)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wt_after_credit)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td>{{ props.item.wt_detail }}</td>
        <td
          class="text-xs-right"
          :style="{ color: calMoney(props.item) > 0 ? 'green' : 'red' }"
        >
          {{ calMoney(props.item) > 0 ? "+" : "" }}{{ calMoney(props.item) }}
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message == false">
          No data available
        </div>
        <div class="text-xs-center" v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import {
  exportFields,
  getExportFileName,
} from "@/utils/exportWalletTransaction";
export default {
  props: {
    loading_message: {},
  },
  data: () => ({
    search: "",
    filteredTransactions: [],
    pagination: {
      page: 1,
      rowsPerPage: 50,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        value: "id",
        sortable: false,
      },
      {
        text: "Date",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Time",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Cash",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Credit",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Details",
        align: "center",
        value: "b_cash",
        sortable: false,
      },
      {
        text: "Changed",
        align: "center",
        value: "b_credit",
        sortable: false,
      },
    ],
    startDate: "",
    endDate: "",
    startMenu: false,
    endMenu: false,
    exportDialog: false,
    exportType: "csv",
    exportSplitCount: 1,
    exportFileList: [],
  }),
  computed: {
    ...mapState({
      rider_wallet_transaction: (state) =>
        state.fetchCashRider.rider_wallet_transaction,
    }),
    pages() {
      this.pagination.totalItems = this.filteredTransactions.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    exportFields() {
      return exportFields;
    },
    maxExportSplit() {
      // Limit split count to avoid too many files
      return Math.min(20, Math.ceil(this.filteredTransactions.length / 100));
    },
    exportFileName() {
      return getExportFileName(
        this.filterProvince,
        this.startDate,
        this.endDate
      );
    },
  },
  methods: {
    calMoney(item) {
      return parseFloat(
        parseFloat(item.wt_after_money) -
          parseFloat(item.wt_before_money) +
          (parseFloat(item.wt_after_credit) - parseFloat(item.wt_before_credit))
      ).toFixed(2);
    },
    filterTransactions() {
      let filtered = [...this.rider_wallet_transaction];
      // Filter by date range (wt_date format: DD/MM/YYYY)
      if (this.startDate) {
        filtered = filtered.filter((item) =>
          moment(item.wt_date, "DD/MM/YYYY").isSameOrAfter(
            moment(this.startDate, "YYYY-MM-DD"),
            "day"
          )
        );
      }
      if (this.endDate) {
        filtered = filtered.filter((item) =>
          moment(item.wt_date, "DD/MM/YYYY").isSameOrBefore(
            moment(this.endDate, "YYYY-MM-DD"),
            "day"
          )
        );
      }
      // Filter by search
      if (this.search && this.search.trim() !== "") {
        const searchTerm = this.search.toLowerCase().trim();
        filtered = filtered.filter(
          (transaction) =>
            transaction.wt_detail &&
            transaction.wt_detail.toLowerCase().includes(searchTerm)
        );
      }
      this.filteredTransactions = filtered;
    },
    initializeTransactions() {
      this.filterTransactions();
    },
    openExportDialog(type) {
      this.exportType = type;
      this.exportDialog = true;
      this.exportSplitCount = 1;
      this.generateExportFileList();
    },
    generateExportFileList() {
      // Split filteredTransactions into exportSplitCount files
      const total = this.filteredTransactions.length;
      const split = Math.max(1, this.exportSplitCount);
      const chunkSize = Math.ceil(total / split);
      this.exportFileList = [];
      for (let i = 0; i < split; i++) {
        const startIdx = i * chunkSize;
        const endIdx = Math.min(startIdx + chunkSize, total);
        const dataChunk = this.filteredTransactions.slice(startIdx, endIdx);
        const name = `${getExportFileName(
          "wallet",
          this.startDate,
          this.endDate
        )}_${i + 1}.${this.exportType}`;
        const range = `Rows ${startIdx + 1} - ${endIdx}`;
        this.exportFileList.push({ name, data: dataChunk, range });
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    rider_wallet_transaction: {
      handler() {
        this.initializeTransactions();
      },
      immediate: true,
    },
    startDate() {
      this.filterTransactions();
      this.generateExportFileList();
    },
    endDate() {
      this.filterTransactions();
      this.generateExportFileList();
    },
    search() {
      this.filterTransactions();
      this.generateExportFileList();
    },
    exportSplitCount() {
      this.generateExportFileList();
    },
  },
  async created() {},
  mounted() {
    this.filterTransactions();
  },
};
</script>

<style scoped>
.export-dialog-card {
  border-radius: 16px;
  overflow: hidden;
}
.export-dialog-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #ffd600 0%, #f39c12 100%);
  gap: 1rem;
}
.header-icon {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-content {
  flex: 1;
}
.header-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
  margin: 0;
}
.header-subtitle {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.8);
  margin: 0.25rem 0 0 0;
}
.close-btn {
  background: rgba(0, 0, 0, 0.1) !important;
  color: black !important;
}
.export-dialog-content {
  padding: 2rem;
  max-height: 70vh;
  overflow-y: auto;
}
.export-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
}
.section-header {
  margin-bottom: 1.5rem;
}
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.form-field {
  margin-bottom: 1rem;
}
.export-dialog-actions {
  padding: 1rem 2rem 1.5rem;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
  gap: 1rem;
}
.download-file-card {
  border-radius: 12px;
  background: #fffbe6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s;
}
.download-file-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.download-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}
.black-btn {
  background: #111 !important;
  color: #fff !important;
  border-radius: 8px;
}
.export-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}
.yellow-btn {
  background: #fddf00 !important;
  color: #111 !important;
  border-radius: 8px;
}
@media (max-width: 768px) {
  .export-dialog-header {
    padding: 1rem 1.5rem;
  }
  .export-dialog-content {
    padding: 1.5rem;
  }
  .form-section {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .export-dialog-actions {
    padding: 1rem 1.5rem;
    flex-direction: column;
  }
}
@media (max-width: 480px) {
  .export-dialog-content {
    padding: 1rem;
  }
  .form-section {
    padding: 0.75rem;
  }
}
</style>
